import React, { Component } from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
    root: {
        margin: '0px auto',
        display: 'block',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
})

class Load extends Component {

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <CircularProgress />
            </div>
        )
    }
}

Load.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Load)